import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { db } from "../Firebase Functions/firebase";
import { collection, doc, setDoc, serverTimestamp, updateDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import UploadCheckRequestToQuickBase from "../Quickbase Functions/UploadCheckRequestToQuickbase";
import "../TruckServices/ChecklistForm.css";

const CheckRequestForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const incidentId = location.state?.incidentId;
    const [modalMessage, setModalMessage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [invoiceImages, setInvoiceImages] = useState([]);
    const [formData, setFormData] = useState({
        supplierNumber: "",
        supplierName: "",
        address: "",
        dateOfRequest: "",
        invoiceNumber: "",
        invoiceDate: "",
        invoiceSentLater: "",
        purpose: "",
        returnTo: "",
        otherName: "",
        overnightMail: false,
        regularMail: false,
        dateNeeded: "",
        checkTotal: "",
        requestedBy: "",
        approvedBy: "",
        expenseDetails: [
          {
            jobNumber: "",
            glAcct: "",
            costCode: "",
            equipmentNumber: "",
            amount: "",
            description: "",
          },
        ],
      });
      
  
    const handleChange = (field, value) => {
      setFormData((prev) => ({ ...prev, [field]: value }));
    };
  
    const handleCheckboxChange = (field) => {
      setFormData((prev) => ({ ...prev, [field]: !prev[field] }));
    };

    const handleExpenseChange = (index, field, value) => {
        const updated = [...formData.expenseDetails];
        updated[index][field] = value;
        setFormData((prev) => ({ ...prev, expenseDetails: updated }));
      };
      
      const addExpenseRow = () => {
        setFormData((prev) => ({
          ...prev,
          expenseDetails: [
            ...prev.expenseDetails,
            {
              jobNumber: "",
              glAcct: "",
              costCode: "",
              equipmentNumber: "",
              amount: "",
              description: "",
            },
          ],
        }));
      };
      
      const removeLastExpenseRow = () => {
        setFormData((prev) => ({
          ...prev,
          expenseDetails: prev.expenseDetails.slice(0, -1),
        }));
      };
      const handleSubmit = async (e) => {
  e.preventDefault();

  if (!incidentId) {
    setModalMessage("Missing incident ID. Please save the incident report first.");
    setShowModal(true);
    return;
  }

  setModalMessage("Uploading invoice images...");
  setShowModal(true);

  try {
    // Upload images to Firebase Storage
    const storage = getStorage();
    const uploadedInvoiceImageURLs = [];

    for (const file of invoiceImages.slice(0, 3)) {
      const fileRef = ref(storage, `checkRequestImages/${incidentId}/invoice-${Date.now()}-${file.name}`);
      await uploadBytes(fileRef, file);
      const downloadURL = await getDownloadURL(fileRef);
      uploadedInvoiceImageURLs.push(downloadURL);
    }

    // Prepare full data including image URLs
    const finalData = {
      ...formData,
      incidentId,
      invoiceImageURLs: uploadedInvoiceImageURLs,
      createdAt: serverTimestamp(),
      checkRequestCompleted: true,
    };

    // Save form data to Firestore
    await setDoc(doc(db, "checkRequestForms", incidentId), finalData);

    setModalMessage("Check Request saved. Uploading to QuickBase...");

    // Upload to QuickBase (PDF generation logic must be inside that function)
    await UploadCheckRequestToQuickBase(incidentId);

    // ✅ Update incidentReports to flag completion
    await updateDoc(doc(db, "incidentReports", incidentId), {
      checkRequestCompleted: true,
    });

    setModalMessage("✅ Check Request uploaded to QuickBase successfully.");
  } catch (error) {
    console.error("Error saving or uploading:", error);
    setModalMessage("❌ Failed to save or upload. Please try again.");
  } finally {
    setShowModal(true);
  }

  navigate("/saved-incident-reports");
};

      
  
      return (
        <form onSubmit={handleSubmit} className="checklist-form" noValidate>
          <h2 className="form-title">Check Request</h2>
  
        <div className="form-group">
          <label>Supplier #</label>
          <input
            type="text"
            value={formData.supplierNumber}
            onChange={(e) => handleChange("supplierNumber", e.target.value)}
            className="form-control"
          />
        </div>
  
        <div className="form-group">
          <label>Supplier Name</label>
          <input
            type="text"
            value={formData.supplierName}
            onChange={(e) => handleChange("supplierName", e.target.value)}
            className="form-control"
          />
        </div>
  
        <div className="form-group">
          <label>Address</label>
          <input
            type="text"
            value={formData.address}
            onChange={(e) => handleChange("address", e.target.value)}
            className="form-control"
          />
        </div>
  
        <div className="form-group">
          <label>Date of Request</label>
          <input
            type="date"
            value={formData.dateOfRequest}
            onChange={(e) => handleChange("dateOfRequest", e.target.value)}
            className="form-control"
          />
        </div>
  
        <div className="form-group">
          <label>Invoice #</label>
          <input
            type="text"
            value={formData.invoiceNumber}
            onChange={(e) => handleChange("invoiceNumber", e.target.value)}
            className="form-control"
          />
        </div>
  
        <div className="form-group">
          <label>Invoice Date</label>
          <input
            type="date"
            value={formData.invoiceDate}
            onChange={(e) => handleChange("invoiceDate", e.target.value)}
            className="form-control"
          />
        </div>
  
        <div className="form-group">
          <label>Will an Invoice Be Sent Later?</label>
          <div className="toggle-buttons">
            <label>
              <input
                type="radio"
                name="invoiceSentLater"
                checked={formData.invoiceSentLater === "yes"}
                onChange={() => handleChange("invoiceSentLater", "yes")}
              />
              Yes
            </label>
            <label style={{ marginLeft: "20px" }}>
              <input
                type="radio"
                name="invoiceSentLater"
                checked={formData.invoiceSentLater === "no"}
                onChange={() => handleChange("invoiceSentLater", "no")}
              />
              No
            </label>
          </div>
        </div>
  
        {/* Purpose */}
        <div className="form-group">
          <label>Purpose</label>
          <textarea
            value={formData.purpose}
            onChange={(e) => handleChange("purpose", e.target.value)}
            className="form-control"
          />
        </div>
  
        {/* Handling Section */}
        <h3 className="section-title">Handling</h3>
  
        <div className="form-group">
          <label>Return Check To:</label>
          <div className="toggle-buttons">
            <label>
              <input
                type="radio"
                name="returnTo"
                checked={formData.returnTo === "requester"}
                onChange={() => handleChange("returnTo", "requester")}
              />
              Requester
            </label>
            <label style={{ marginLeft: "20px" }}>
              <input
                type="radio"
                name="returnTo"
                checked={formData.returnTo === "other"}
                onChange={() => handleChange("returnTo", "other")}
              />
              Other
            </label>
          </div>
          {formData.returnTo === "other" && (
            <input
              type="text"
              placeholder="Enter name"
              value={formData.otherName}
              onChange={(e) => handleChange("otherName", e.target.value)}
              className="form-control"
            />
          )}
        </div>
  
        <div className="form-group">
          <label>
            <input
              type="checkbox"
              checked={formData.overnightMail}
              onChange={() => handleCheckboxChange("overnightMail")}
            />
            Overnight Mail (Include Address)
          </label>
          <label style={{ marginLeft: "20px" }}>
            <input
              type="checkbox"
              checked={formData.regularMail}
              onChange={() => handleCheckboxChange("regularMail")}
            />
            Regular Mail (Include Address)
          </label>
        </div>
  
        <div className="form-group">
          <label>Date Check is Needed</label>
          <input
            type="date"
            value={formData.dateNeeded}
            onChange={(e) => handleChange("dateNeeded", e.target.value)}
            className="form-control"
          />
        </div>
  
        {/* Financial Table */}
        <h3 className="section-title">Expense Details</h3>
{formData.expenseDetails?.map((row, index) => (
  <div className="grid grid-cols-6 gap-2 items-center mb-2" key={index}>
    <input
      placeholder="Job #"
      className="form-control"
      value={row.jobNumber}
      onChange={(e) => handleExpenseChange(index, "jobNumber", e.target.value)}
    />
    <input
      placeholder="GL Acct"
      className="form-control"
      value={row.glAcct}
      onChange={(e) => handleExpenseChange(index, "glAcct", e.target.value)}
    />
    <input
      placeholder="Cost Code"
      className="form-control"
      value={row.costCode}
      onChange={(e) => handleExpenseChange(index, "costCode", e.target.value)}
    />
    <input
      placeholder="Equipment #"
      className="form-control"
      value={row.equipmentNumber}
      onChange={(e) => handleExpenseChange(index, "equipmentNumber", e.target.value)}
    />
    <input
      placeholder="Amount"
      className="form-control"
      value={row.amount}
      onChange={(e) => handleExpenseChange(index, "amount", e.target.value)}
    />
    <input
      placeholder="Description"
      className="form-control"
      value={row.description}
      onChange={(e) => handleExpenseChange(index, "description", e.target.value)}
    />
  </div>
))}

<div style={{ marginTop: "1rem", display: "flex", gap: "10px" }}>
  <button
    type="button"
    onClick={addExpenseRow}
    className="secondary-button"
  >
    + Add Another
  </button>
  {formData.expenseDetails.length > 1 && (
    <button
      type="button"
      onClick={removeLastExpenseRow}
      className="modal-close-button"
    >
      Remove Last
    </button>
  )}
</div>

  
        <div className="form-group" style={{ marginTop: "1rem" }}>
          <label>Check Total</label>
          <input
            type="text"
            className="form-control"
            value={formData.checkTotal}
            onChange={(e) => handleChange("checkTotal", e.target.value)}
          />
        </div>
  
        <div className="form-group" style={{ display: "flex", gap: "20px" }}>
      <input
        type="text"
        placeholder="Requested By"
        className="form-control"
        value={formData.requestedBy}
        onChange={(e) => handleChange("requestedBy", e.target.value)}
      />
      <input
        type="text"
        placeholder="Approved By"
        className="form-control"
        value={formData.approvedBy}
        onChange={(e) => handleChange("approvedBy", e.target.value)}
      />
    </div>
    <div className="form-group">
  <label>Upload Invoice Images (max 3)</label>
  <input
    type="file"
    accept="image/*"
    multiple
    onChange={(e) => {
      const files = Array.from(e.target.files).slice(0, 3); // Limit to 3
      setInvoiceImages(files);
    }}
  />
  <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
    {invoiceImages.map((img, index) => (
      <div key={index}>
        <img
          src={URL.createObjectURL(img)}
          alt={`Preview ${index + 1}`}
          width={100}
          height="auto"
          style={{ borderRadius: "4px", border: "1px solid #ccc" }}
        />
      </div>
    ))}
  </div>
</div>


    {/* Submit Button */}
    <button type="submit" className="secondary-button" style={{ marginTop: "1.5rem" }}>
      Save Check Request
    </button>

    {/* Modal for feedback */}
    {showModal && (
      <div className="custom-modal-overlay">
        <div className="custom-modal">
          <h2>Notice</h2>
          <p>{modalMessage}</p>
          <button className="modal-close-button" onClick={() => setShowModal(false)}>
            OK
          </button>
        </div>
      </div>
    )}
  </form>
);
};
  
  export default CheckRequestForm;